module.exports = __webpack_public_path__ + "img/more-horizontal.14e01dfc.svg";